module.exports = __webpack_public_path__ + "static/landing-fe4a4c324156778f852d330e7ca8b838.jpg";